import { Icon } from '@chakra-ui/react';
import { FiPercent } from 'react-icons/fi';
import React from 'react';

function PercentIcon() {
  return <Icon as={FiPercent} color="gray.500" />;
}

export default PercentIcon;
